import inputData from "@/data/input";
import selectionsData from "@/data/selections";

const {
    videoDistributionClients: videoDistributionClientsSelectionKey,
    territories: territoriesSelectionKey,
    videos: videosSelectionKey,
} = selectionsData.keys;

const {
    autoComplete: autoCompleteInputType,
    date: dateInputType,
    multiAutoComplete: multiAutoCompleteInputType,
} = inputData.types;

const {
    client: clientInputName,
    releaseDate: releaseDateInputName,
    territory: territoryInputName,
    videos: videosInputName,
} = inputData.names;

const {
    client: clientInputLabel,
    releaseDate: releaseDateInputLabel,
    territory: territoryInputLabel,
    videos: videosInputLabel,
} = inputData.labels;

const releaseVideoDistributionFormData = [
    {
        // narrowed server-side to VIDEO_DISTRIBUTION clients and fetched unpaginated, so it needs no async search/scroll
        col: { xs: 12 },
        label: clientInputLabel,
        name: clientInputName,
        selectionKey: videoDistributionClientsSelectionKey,
        type: autoCompleteInputType,
    },
    {
        col: { xs: 12 },
        isAsyncMenu: true,
        label: territoryInputLabel,
        name: territoryInputName,
        selectionKey: territoriesSelectionKey,
        type: autoCompleteInputType,
    },
    {
        col: { xs: 12 },
        label: videosInputLabel,
        name: videosInputName,
        selectionKey: videosSelectionKey,
        type: multiAutoCompleteInputType,
    },
    {
        col: { xs: 12 },
        label: releaseDateInputLabel,
        name: releaseDateInputName,
        type: dateInputType,
    },
];

export default releaseVideoDistributionFormData;
